<template>
  <div class="products-dropdown hide-on-mobile">
    <div class="products-dropdown__trigger" @click="isDropdownVisible = !isDropdownVisible">
      <span class="products-dropdown__trigger-text">Products</span>
      <IconEmbedded :name="isDropdownVisible ? 'caret-top_4' : 'caret-bottom_4'" :size="12" />
    </div>
    <div v-if="isDropdownVisible" class="products-dropdown__menu" v-click-outside="() => (isDropdownVisible = false)">
      <a class="products-dropdown__menu-item" @click="scrollToSection('atlas-social-section')">Atlas Social</a>
      <a class="products-dropdown__menu-item" @click="scrollToSection('creator-suite-section')">Creator Suite</a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";

defineOptions({ name: "ProductsDropdown" });

const isDropdownVisible = ref(false);

function scrollToSection(sectionId: string) {
  isDropdownVisible.value = false;
  document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
}
</script>

<style scoped lang="scss">
.products-dropdown {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 20px;
  padding: 0 8px;

  &__trigger {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    padding: 0;
    user-select: none;
    transition: all 0.1s ease;

    &:hover {
      .products-dropdown__trigger-text {
        color: #058587;
      }
    }
  }

  &__trigger-text {
    font-size: 20px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    transition: color 0.1s ease;
  }

  &__menu {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    min-width: 180px;
    padding: 8px 0;
    background: #fff;
    border-radius: 4px;
    box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.12),
      0 0 0 1px rgba(0, 0, 0, 0.05);
    z-index: 10000;
    animation: slideDown 0.15s ease-out;
  }

  &__menu-item {
    display: block;
    padding: 11px 18px;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    text-decoration: none;
    transition:
      background-color 0.1s ease,
      color 0.1s ease;

    &:hover {
      background-color: rgba(5, 133, 135, 0.08);
      color: #058587;
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
